function getBootstrapModal(element) {
  const Modal = window.bootstrap?.Modal;
  if (!Modal || !element) return null;
  return Modal.getOrCreateInstance(element);
}

function setFeedback(element, message, type = 'danger') {
  if (!element) return;
  if (!message) {
    element.classList.add('d-none');
    element.textContent = '';
    element.classList.remove('alert-danger', 'alert-success');
    return;
  }
  element.classList.remove('d-none', 'alert-danger', 'alert-success');
  element.classList.add(type === 'success' ? 'alert-success' : 'alert-danger');
  element.textContent = message;
}

function appendProviderOption(selectEl, provider) {
  if (!selectEl || !provider?.id) return;
  const existingOption = Array.from(selectEl.options).find((option) => option.value === provider.id);
  if (existingOption) {
    existingOption.selected = true;
  } else {
    const option = new Option(provider.name || 'Nuevo proveedor', provider.id, true, true);
    selectEl.add(option);
  }
  selectEl.dispatchEvent(new Event('change', { bubbles: true }));
}

export function initFinanceExpensesPage() {
  const providerSelect = document.getElementById('providerId');
  const modalElement = document.getElementById('providerQuickAddModal');
  const modalForm = modalElement?.querySelector('[data-provider-form]');
  const submitButton = modalElement?.querySelector('[data-submit-btn]');
  const feedbackElement = modalElement?.querySelector('[data-feedback]');

  if (!providerSelect || !modalElement || !modalForm || !submitButton) {
    return;
  }

  const modalInstance = getBootstrapModal(modalElement);

  const nameInput = modalForm.querySelector('input[name="name"]');
  const phoneInput = modalForm.querySelector('input[name="phone"]');
  const emailInput = modalForm.querySelector('input[name="email"]');

  const setLoading = (state) => {
    submitButton.disabled = state;
    submitButton.dataset.originalText = submitButton.dataset.originalText || submitButton.textContent;
    submitButton.textContent = state ? 'Guardando...' : submitButton.dataset.originalText;
  };

  modalElement.addEventListener('hidden.bs.modal', () => {
    modalForm.reset();
    setFeedback(feedbackElement, '');
    setLoading(false);
  });

  modalForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    setFeedback(feedbackElement, '');

    const payload = {
      name: nameInput.value.trim(),
      phone: phoneInput.value.trim(),
      email: emailInput.value.trim()
    };

    if (!payload.name) {
      setFeedback(feedbackElement, 'El nombre del proveedor es obligatorio.');
      nameInput.focus();
      return;
    }

    try {
      setLoading(true);
      const response = await fetch('/finance/providers/quick-create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json().catch(() => null);
      if (!response.ok || !data) {
        throw new Error(data?.errors?.[0] || 'No se pudo crear el proveedor.');
      }

      if (!data.success) {
        setFeedback(feedbackElement, Array.isArray(data.errors) ? data.errors.join(' ') : (data.message || 'Ocurrió un error.'));
        return;
      }

      const provider = data.provider;
      appendProviderOption(providerSelect, provider);

      if (modalInstance) {
        modalInstance.hide();
      }

      if (data.exists && data.message) {
        if (window.Swal) {
          window.Swal.fire({
            icon: 'info',
            title: 'Proveedor existente',
            text: data.message,
            confirmButtonText: 'Aceptar'
          });
        } else {
          window.alert(data.message);
        }
      } else if (window.Swal) {
        window.Swal.fire({
          icon: 'success',
          title: 'Proveedor agregado',
          text: 'El proveedor se añadió correctamente.',
          timer: 1800,
          showConfirmButton: false
        });
      } else {
        window.alert('Proveedor agregado correctamente.');
      }
    } catch (error) {
      setFeedback(feedbackElement, error.message || 'No se pudo crear el proveedor.');
    } finally {
      setLoading(false);
    }
  });
}
